// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: white;
  overflow-y: auto;
}

/* Global styles for consistent spacing */
.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  font-size: 20px;
}

/* Responsive design */
@media (max-width: 768px) {
  .app {
    flex-direction: column;
  }
  
  .main-content {
    flex: 1 1;
    min-height: calc(100vh - 200px);
  }
}

/* Smooth transitions */
* {
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Focus styles for accessibility */
button:focus,
select:focus,
input:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Loading states */
.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Error states */
.error {
  color: #ef4444;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  padding: 8px 12px;
  border-radius: 4px;
  margin: 8px 0;
}

/* Success states */
.success {
  color: #22c55e;
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
  padding: 8px 12px;
  border-radius: 4px;
  margin: 8px 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,+BAA+B;EACjC;AACF;;AAEA,uBAAuB;AACvB;EACE,+EAA+E;AACjF;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".app {\n  display: flex;\n  min-height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  overflow-y: auto;\n}\n\n/* Global styles for consistent spacing */\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #111827;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.title-icon {\n  font-size: 20px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .app {\n    flex-direction: column;\n  }\n  \n  .main-content {\n    flex: 1;\n    min-height: calc(100vh - 200px);\n  }\n}\n\n/* Smooth transitions */\n* {\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Focus styles for accessibility */\nbutton:focus,\nselect:focus,\ninput:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Loading states */\n.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Error states */\n.error {\n  color: #ef4444;\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin: 8px 0;\n}\n\n/* Success states */\n.success {\n  color: #22c55e;\n  background-color: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin: 8px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
